"use client";
import React, { useState, useEffect } from 'react';

export default function ProtectedEmail({ email, className, style }: { email: string, className?: string, style?: React.CSSProperties }) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!email) return null;

  // Render obfuscated version during SSR so bots don't easily scrape it via regex
  if (!isMounted) {
    const parts = email.split('@');
    if (parts.length !== 2) return <span className={className} style={style}>{email}</span>;
    return (
      <span className={className} style={style}>
        {parts[0]}<span style={{ display: 'none' }}>_</span>@<span style={{ display: 'none' }}>_</span>{parts[1]}
      </span>
    );
  }

  // Once hydrated on the client, render the actual mailto link
  return (
    <a href={`mailto:${email}`} className={className} style={{ color: 'inherit', textDecoration: 'none', ...style }}>
      {email}
    </a>
  );
}
